export default __webpack_public_path__ + "static/media/x-social.cc092703.svg";